import { useIsFocused } from "@react-navigation/native";
import { useContext, useEffect, useState } from "react";
import { ScrollView, StyleSheet, Text, View } from "react-native";
import { Masks, createNumberMask } from "react-native-mask-input";
import PageTitle from "../../components/PageTitle";
import CaixaTextoInputIcone from "../../components/TextBoxIcon";
import { AuthContext } from "../../contexts/auth";
import { GlobalContext } from "../../contexts/global";
import Validade from "../../helpers/validate";
import { GetUserByDocument } from "../../services/Api/user";
import {
  GetShareWalletUsers,
  RemoveSharedWalletOwner,
  ShareWallet
} from "../../services/Api/walletShared";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";
import OptionUser from "./components/OptionUser";

export default function WalletShared({ navigation, route }) {
  const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [limit, setLimit] = useState(null)
  const [sharedUsers, setSharedUsers] = useState([]);
  const [userInfo, setUserInfo] = useState(null);
  useEffect(() => setLoading({
    show: true,
    message: "Carregando usuarios compartilhados",
  }), [])
  const [validCpfCnpj, setValidCpfCnpj] = useState({
    isValid: true,
    invalidMessage: "Digite um CPF/CNPJ válido",
  });
  const { emailUser } = useContext(AuthContext);
  const isFocused = useIsFocused();
  const params = route.params;

  useEffect(() => {
    if (!!cpfCnpj) {
      if (cpfCnpj.length == 11) {
        if (!Validade.validDocument(cpfCnpj.trim())) {
          setValidCpfCnpj({ ...validCpfCnpj, isValid: false });
          setUserInfo(null);
        } else {
          setValidCpfCnpj({ ...validCpfCnpj, isValid: true });
          getUserIdByDocument(cpfCnpj);
        }
      } else if (cpfCnpj.length == 14) {
        if (!Validade.CNPJ(cpfCnpj.trim())) {
          setValidCpfCnpj({ ...validCpfCnpj, isValid: false });
          setUserInfo(null);
        } else {
          setValidCpfCnpj({ ...validCpfCnpj, isValid: true });
          getUserIdByDocument(cpfCnpj);
        }
      }
    } else {
      setUserInfo(null);
    }
  }, [cpfCnpj]);

  useEffect(() => {
    if (isFocused) {
      updateList();
    }
  }, [isFocused]);

  const getUserIdByDocument = (document) => {
    GetUserByDocument(document)
      .then((value) => {
        if (value.data.email == emailUser) {
          setShowAlert({
            type: "warning",
            title: "Atenção",
            message: "Não pode adicionar a conta atual para compartilhar",
            show: true,
            confirmText: "OK",
            pressConfirm: () => {
              setShowAlert({ show: false });
            },
          });
        } else {
          setUserInfo(value.data);
        }
      })
      .catch((error) => {
        setUserInfo(null);
        setShowAlert({
          type: "warning",
          title: "Não foi possível recuperar o documento",
          message: error.erro ? error.erro : "Não informado",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ show: false });
          },
        });
      });
  };
  
  const shareWallet = (userId) => {
    setLoading({ show: true, message: "Adicionando usúario na carteira" });
    ShareWallet(userId, limit ? (limit / 100) : 0)
      .then((value) => {
        setShowAlert({
          type: "success",
          title: "Sucesso",
          message: "Usuário adicionado",
          show: true,
          confirmText: "OK",
          pressCancel: () => { },
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
          showConfirmButton: true,
        });
      })
      .catch((error) => {
        setShowAlert({
          type: "alert",
          title: "Não foi possível adicionar o usuário",
          message: error.erro ? error.erro : "Não informado",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ show: false });
          },
        });
      })
      .finally(() => {
        updateList()
        setCpfCnpj("")
        setLimit(null)
        setLoading({ show: false, message: "" });
      });
  };

  const updateList = () => {
    GetShareWalletUsers()
      .then((value) => {
        setSharedUsers(value.data);
      })
      .catch((error) => {
        setShowAlert({
          type: "alert",
          title: "Oops",
          message: (error.erro ?? error.message) ?? "Erro ao tentar carregar os usuarios compartilhados",
          show: true,
          confirmText: "OK",
          pressCancel: () => { },
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setLoading({ show: false, message: "" });
      });
  };

  const deleteSharedUserHandler = (userShared) => {
    setShowAlert({
      type: "warning",
      title: "Atenção",
      message: `Deseja mesmo remover o usuário ${userShared.userEmail} do compartilhamento?`,
      show: true,
      confirmText: "Sim",
      cancelText: "Não",
      pressCancel: () => {
        setShowAlert({ ...showAlert, show: false });
      },
      pressConfirm: () => {
        setLoading({ show: true, message: "Removendo usuario compartilhado" });
        deleteSharedUser(userShared, params.idWallet);
        setShowAlert({ ...showAlert, show: false });
      },
      showConfirmButton: true,
    });
  };

  const deleteSharedUser = (user, idWallet) => {
    RemoveSharedWalletOwner(idWallet, user.walletId, user.userId)
      .then((value) => {
        setShowAlert({
          type: "success",
          title: "Sucesso",
          message: "Usuário removido",
          show: true,
          confirmText: "OK",
          pressCancel: () => { },
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
          showConfirmButton: true,
        });
      })
      .catch((error) => {
        setShowAlert({
          type: "alert",
          title: "Erro ao tentar remover o usuarios do compartilhamento",
          message: error.erro ? error.erro : "Não informado",
          show: true,
          confirmText: "OK",
          pressCancel: () => { },
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
          showConfirmButton: true,
        })
      }).finally(() => {
        updateList();
        setLoading({ show: false, message: "" });
      });;
  };

  const brlMask = createNumberMask({
    delimiter: '.',
    separator: ',',
    precision: 2,
  })

  return (
    <PageTitle navigation={navigation} title={"Compartilhar carteira"}>
      <View style={styles.documentView}>
        <CaixaTextoInputIcone
          iconName={"file-document-outline"}
          placeholderInput={"CPF ou CNPJ"}
          keyboardType={"numeric"}
          onChangeTextInput={(cpfmask, cpf) => setCpfCnpj(cpf)}
          maskInput={Masks.BRL_CPF_CNPJ}
          value={cpfCnpj}
          textContentType="none"
          {...validCpfCnpj}
          styleBox={{ width: "100%", marginBottom: 8 }}
        />
         <CaixaTextoInputIcone
          iconName={"currency-usd"}
          placeholderInput={"Limite (Opcional)"}
          keyboardType={"numeric"}
          onChangeTextInput={(limiteMask, limit) => setLimit(limit)}
          maskInput={brlMask}
          value={limit}
          textContentType="none"
      
          styleBox={{ width: "100%", marginBottom: 8 }}
        />
        {!!userInfo ? (
          <OptionUser
            title={userInfo.name}
            subtitle={userInfo.email}
            action={() => shareWallet(userInfo.id)}
            icon={"plus"}
            iconColor={Colors.SUCCESS}
          />
        ) : null}
        <View style={styles.sharedUsersView}>
          <Text style={styles.sharedUsersText}>
            {"USÚARIOS COMPARTILHADOS"}
          </Text>
          {sharedUsers.length > 0 ? (
            <ScrollView>
              {sharedUsers.map((user) => {
                return (
                  <OptionUser
                    title={user.userName}
                    subtitle={user.userEmail}
                    key={user.userId}
                    icon={"trash-can-outline"}
                    action={() => deleteSharedUserHandler(user)}
                    iconColor={Colors.ALERT}
                    limit={user.walletValueShared}
                  />
                );
              })}
            </ScrollView>
          ) : null}
        </View>
      </View>
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  documentView: {
    marginTop: 8,
  },
  userInfoView: {
    paddingHorizontal: 8,
  },
  sharedUsersText: {
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "500",
  },
  sharedUsersView: {
    alignItems: "center",
  },
});
